import { memo } from 'react';
import styled from '@emotion/styled';

export const SecondaryButton = memo(
  styled.button`
    box-sizing: border-box;
    min-width: 100px;
    padding: 10px;
    border-radius: 5px;
    border-style: solid;
    border-width: 2px;

    font-family: ${({ theme }) => theme.fonts.bold};
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: background-color 180ms ease-in-out, border 120ms ease-in, border-color 120ms ease-in, color 120ms ease-in;

    background-color: ${({ theme }) => theme.palette.btnSecondary.bg};
    border-color: ${({ theme }) => theme.palette.btnSecondary.border};
    color: ${({ theme }) => theme.palette.btnSecondary.color};

    &:hover {
      color: ${({ theme }) => theme.palette.btnSecondary.active.color};
      background-color: ${({ theme }) => theme.palette.btnSecondary.active.bg};
      border-color: ${({ theme }) => theme.palette.btnSecondary.active.border};
    }

    &:disabled {
      cursor: initial;
      color: ${({ theme }) => theme.palette.btnSecondary.disabled.color};
      background-color: ${({ theme }) => theme.palette.btnSecondary.disabled.bg};
      border-color: ${({ theme }) => theme.palette.btnSecondary.disabled.border};
    }
  `,
);